@if (hasInputMaterials()) {
<div class="accepted-materials section-margin-xs">
  <div class="section-title margin-b-xs">
    <span class="head-medium text-secondary">{{ inputTitle | t }}</span>
  </div>
  <app-materials-pills [displayOnly]="true" [displayMaterials]="inputMaterials()" [showSearch]="false"
    [pillSize]="pillSize">
  </app-materials-pills>
</div>
}

@if (hasOutputMaterials()) {
<div class="output-materials section-margin-s">
  <div class="section-title margin-b-xs">
    <span class="head-medium text-secondary">{{ outputTitle | t }}</span>
  </div>
  <app-materials-pills [displayOnly]="true" [displayMaterials]="outputMaterials()" [showSearch]="false"
    [pillSize]="pillSize">
  </app-materials-pills>
</div>
}
